import * as React from "react";

export const PendingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 0.818182C2.46657 0.818182 0.818182 2.46657 0.818182 4.5C0.818182 6.53343 2.46657 8.18182 4.5 8.18182C6.53343 8.18182 8.18182 6.53343 8.18182 4.5C8.18182 2.46657 6.53343 0.818182 4.5 0.818182ZM0 4.5C0 2.01469 2.01469 0 4.5 0C6.98531 0 9 2.01469 9 4.5C9 6.98531 6.98531 9 4.5 9C2.01469 9 0 6.98531 0 4.5Z"
      fill="#FF7A36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4.57143V2H4.66667V4.14286H6V5H4.33333C4.14927 5 4 4.80809 4 4.57143Z"
      fill="#FF7A36"
    />
  </svg>
);
